import { Routes } from '@angular/router';

export const routes: Routes = [
  // {
  //   path: 'home',
  //   loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  // },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'vendor',
    loadComponent: () => import('./vendor-login/vendor-login.page').then( m => m.VendorLoginPage)
  },
  {
    path: 'register',
    loadComponent: () => import('./register/register.page').then( m => m.RegisterPage)
  },
  {
    path: 'register-post',
    loadComponent: () => import('./register-post/register-post.page').then( m => m.RegisterPostPage)
  },
  {
    path: 'home-main',
    loadComponent: () => import('./home-main/home-main.page').then( m => m.HomeMainPage),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        loadComponent: () => import('./home/home.page').then( m => m.HomePage)
      },
      {
        path: 'settings',
        loadComponent: () => import('./settings/settings.page').then( m => m.SettingsPage)
      },
      {
        path: 'video-list',
        loadComponent: () => import('./video-list/video-list.page').then( m => m.VideoListPage)
      },
      {
        path: 'upload',
        loadComponent: () => import('./upload/upload.page').then( m => m.UploadPage)
      },
    
      {
        path: 'likes',
        loadComponent: () => import('./likes/likes.page').then( m => m.LikesPage)
      },
      {
        path: 'my-playlists',
        loadComponent: () => import('./my-playlists/my-playlists-shell.page').then((m) => m.MyPlaylistsShellPage),
        children: [
          {
            path: '',
            loadComponent: () => import('./my-playlists/my-playlists.page').then((m) => m.MyPlaylistsPage),
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./playlist-detail/playlist-detail.page').then((m) => m.PlaylistDetailPage),
          },
        ],
      },
      {
        path: 'playlist-detail/:id',
        redirectTo: 'my-playlists/detail/:id',
        pathMatch: 'full',
      },
      {
        path: 'lesson-list',
        loadComponent: () => import('./lesson-list/lesson-list.page').then( m => m.LessonListPage)
      },
      {
        path: 'video-for-my-department',
        loadComponent: () => import('./video-for-my-department/video-for-my-department.page').then( m => m.VideoForMyDepartmentPage)
      },
      {
        path: 'lesson-detail/:id',
        loadComponent: () => import('./lesson-detail/lesson-detail.page').then(m => m.LessonDetailPage)
      },
      {
        path: 'certificate-list',
        loadComponent: () => import('./certification-list/certification-list.page').then(m => m.CertificationListPage)
      },
      {
        path: 'manage-course',
        loadComponent: () => import('./my-course/my-course.page').then(m => m.MyCoursePage)
      }
    ]
  },
  {
    path: 'upload',
    loadComponent: () => import('./upload/upload.page').then( m => m.UploadPage)
  },
  {
    path: 'upload/:id',
    loadComponent: () => import('./upload/upload.page').then( m => m.UploadPage)
  },
  {
    path: 'profile-edit',
    loadComponent: () => import('./profile-edit/profile-edit.page').then( m => m.ProfileEditPage)
  },
  {
    path: 'modal-menu',
    loadComponent: () => import('./modal/modal-menu/modal-menu.page').then( m => m.ModalMenuPage)
  },
  {
    path: 'watch-later',
    loadComponent: () => import('./watch-later/watch-later.page').then( m => m.WatchLaterPage)
  },
  {
    path: 'library',
    loadComponent: () => import('./library/library.page').then( m => m.LibraryPage)
  },
  {
    path: 'personal-channel',
    loadComponent: () => import('./personal-channel/personal-channel.page').then( m => m.PersonalChannelPage)
  },
  {
    path: 'personal-channel/:id',
    loadComponent: () => import('./personal-channel/personal-channel.page').then( m => m.PersonalChannelPage)
  },
  {
    path: 'pov-plus',
    loadComponent: () => import('./pov-plus/pov-plus.page').then( m => m.PovPlusPage)
  },
  {
    path: 'pov-plus-detail',
    loadComponent: () => import('./pov-plus-detail/pov-plus-detail.page').then( m => m.PovPlusDetailPage)
  },
  {
    path: 'register-profile',
    loadComponent: () => import('./register-profile/register-profile.page').then( m => m.RegisterProfilePage)
  },
  {
    path: 'watch',
    loadComponent: () => import('./watch/watch.page').then( m => m.WatchPage)
  },
  {
    path: 'watch/:id',
    loadComponent: () => import('./watch/watch.page').then(m => m.WatchPage)
  },
  {
    path: 'modal-playlist',
    loadComponent: () => import('./modal/modal-playlist/modal-playlist.page').then( m => m.ModalPlaylistPage)
  },
  {
    path: 'video-list-detail',
    loadComponent: () => import('./video-list-detail/video-list-detail.page').then( m => m.VideoListDetailPage)
  },
  {
    path: 'video-list-detail/:id',
    loadComponent: () => import('./video-list-detail/video-list-detail.page').then( m => m.VideoListDetailPage)
  },
  {
    path: 'modal-sort-filter',
    loadComponent: () => import('./modal/modal-sort-filter/modal-sort-filter.page').then( m => m.ModalSortFilterPage)
  },
  {
    path: 'certification-list',
    loadComponent: () => import('./certification-list/certification-list.page').then(m => m.CertificationListPage)
  },
  {
    path: 'quiz',
    loadComponent: () => import('./quiz/quiz.page').then( m => m.QuizPage)
  },
  {
    path: 'quiz/:id',
    loadComponent: () => import('./quiz/quiz.page').then(m => m.QuizPage)
  },
  {
    path: 'my-course',
    loadComponent: () => import('./my-course/my-course.page').then( m => m.MyCoursePage)
  },
  {
    path: 'my-course-edit',
    loadComponent: () => import('./my-course-edit/my-course-edit.page').then( m => m.MyCourseEditPage)
  },
  {
    path: 'my-course-edit/:id',
    loadComponent: () => import('./my-course-edit/my-course-edit.page').then(m => m.MyCourseEditPage)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.page').then( m => m.ForgotPasswordPage)
  },
  {
    path: 'delete-account',
    loadComponent: () => import('./delete-account/delete-account.page').then( m => m.DeleteAccountPage)
  },
  {
    path: 'change-password',
    loadComponent: () => import('./change-password/change-password.page').then( m => m.ChangePasswordPage)
  },
  {
    path: 'help-center',
    loadComponent: () => import('./help-center/help-center.page').then( m => m.HelpCenterPage)
  },
  {
    path: 'pricing-plan',
    loadComponent: () => import('./pricing-plan/pricing-plan.page').then( m => m.PricingPlanPage)
  },
  {
    path: 'payment-confirm',
    loadComponent: () => import('./payment-confirm/payment-confirm.page').then( m => m.PaymentConfirmPage)
  },
  {
    path: 'my-subscription',
    loadComponent: () => import('./my-subscription/my-subscription.page').then( m => m.MySubscriptionPage)
  },
  {
    path: 'manage-video/:id',
    loadComponent: () => import('./manage-video/manage-video.page').then( m => m.ManageVideoPage)
  },
  {
    path: 'edit-video/:id',
    loadComponent: () => import('./edit-video/edit-video.page').then( m => m.EditVideoPage)
  },




  // {
  //   path: 'video-list',
  //   loadComponent: () => import('./video-list/video-list.page').then( m => m.VideoListPage)
  // },
];
